import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-90523ab6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "icon" }
const _hoisted_3 = { class: "text" }
const _hoisted_4 = { class: "text-m-light" }
const _hoisted_5 = {
  key: 0,
  class: "text-s-faint"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_use_svg = _resolveComponent("use-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_use_svg, {
        svg: "circle-check",
        height: 25,
        width: 25
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.formatDate(_ctx.task.startDate, 'PPP')), 1),
      (_ctx.task.polygonEmployee)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.task.polygonEmployee.name), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}